<template>
  <div>
     <el-button type="primary" v-auth="'test:btn:add'">新增</el-button>
     <el-button type="primary" v-auth="'test:btn:download'">下载</el-button>
     <el-button type="primary" v-auth="'test:btn:delete'">删除</el-button>
     <el-button type="primary" v-auth="'test:btn:check'">查询</el-button>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>